// Services
import NotificationService from '@/app/services/main/notifications/notifications-service.js';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export const notificationMixins = {
    data() {
		return {
			notificationListDropDown : [],
			notificationListPage : [],
			isNotificationLoading: false
        }
    },
    methods: {
		setNotificationList({ queryParams, isPage }) {
			this.isNotificationLoading = true;
			if (!isPage) {
				queryParams['f_read'] = false;
			}
			NotificationService.getAdminNotificationList(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						}
						this.$emit('notificationCount', res.data.unreadCount);
					}
					this.isNotificationLoading = false;
				});
		},
		markReadNotification(notification) {
			return NotificationService.putNotification(notification.id)
				.then(res => {
					if (res.status !== STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showGenericErrorToast();
					} 
				});
		},
    }
}